module.exports = __webpack_public_path__ + "a483865cd12bd94730b1a6fa12e10fa4.png";